var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from '../../styles/styled';
import { STATE, } from '../constants';
import { getSizeStyle, getIconMargin, getCursor, getBorderStyle, getFontStyle, getFontColor, getIcon, getBackGroundColor, getImageStyle, } from './helpers';
import getOverrides from '../../overrides/helper';
const Root = styled.button `
  position: relative;
  border-radius:  ${({ theme }) => theme.borders.radius50};
  background-color:   ${(props) => {
    const { theme, dismissible, disabled, selected, } = props;
    return getBackGroundColor({
        theme, dismissible, disabled, selected,
    });
}};
  display: flex;
  align-items: center;
  width: fit-content;
  ${(props) => {
    const { size, theme, dismissible, selected, disabled, } = props;
    const border = getBorderStyle({
        theme, dismissible, selected, disabled,
    });
    const sizeStyle = getSizeStyle({ size, theme });
    return Object.assign(Object.assign({}, border), sizeStyle);
}};
@media(hover: hover) {
  &:hover {
    cursor: ${(props) => {
    const { disabled } = props;
    return getCursor({ disabled });
}};
    background-color:  ${(props) => {
    const { theme, dismissible, selected, disabled, } = props;
    return getBackGroundColor({
        theme, dismissible, disabled, selected, state: STATE.hover,
    });
}};
    ${(props) => {
    const { theme, dismissible, selected, disabled, } = props;
    const border = getBorderStyle({
        theme, dismissible, disabled, selected, state: STATE.hover,
    });
    return Object.assign({}, border);
}};

  }
  &:focus {
    background-color:  ${(props) => {
    const { theme, dismissible, disabled, selected, } = props;
    return getBackGroundColor({
        theme, dismissible, disabled, state: STATE.focus, selected,
    });
}};
  }
}
&:active {
  background-color: ${(props) => {
    const { theme, dismissible, disabled, selected, } = props;
    return getBackGroundColor({
        theme, dismissible, disabled, state: STATE.focus, selected,
    });
}};
}

${({ $style }) => $style};
`;
const Label = styled.span `

  padding:0;
  margin: 0;
  color: ${(props) => {
    const { theme, dismissible, disabled, selected, } = props;
    return getFontColor({
        theme, dismissible, disabled, selected,
    });
}};
${(props) => {
    const { size, theme } = props;
    const sizeStyle = getFontStyle({ size, theme });
    return Object.assign({}, sizeStyle);
}}
`;
const Icon = styled.div `
  margin-right: 10px;
  height: 11px;
  width: 12px;
  ${(props) => {
    const { theme, size } = props;
    const style = getIconMargin({ theme, size });
    return Object.assign({}, style);
}};
  ${({ $style }) => $style};
`;
// svg path {
//   fill: ${({
//   theme, dismissible, disabled, selected,
// }) => getFontColor({
//   theme, dismissible, disabled, selected,
// })};
// }
const ClosedIcon = styled.div `
  margin-left: 9px;
  height: 14px;
  width: 14px;

  svg {
  & path {
    fill: ${({ theme }) => theme.colors.secondary};
  }
  }

`;
const StyledImage = styled.div `
height: 16px;
width: 16px;
margin-right: 8px;
border-radius: 12px;
${(props) => {
    const { imgSrc, theme, size } = props;
    const style = getImageStyle({ theme, imgSrc, size });
    return Object.assign({}, style);
}};

`;
const Component = (props) => {
    const { onClick } = props, rest = __rest(props, ["onClick"]);
    const { label, icon, dismissible, imgSrc, onDismiss, overrides, } = rest;
    const iconOverride = getOverrides('Icon', overrides);
    const rootOverride = getOverrides('Root', overrides);
    return (React.createElement(Root, Object.assign({}, props, rootOverride),
        imgSrc && (React.createElement(StyledImage, Object.assign({}, rest))),
        !imgSrc && icon && (React.createElement(Icon, Object.assign({}, rest, iconOverride), icon)),
        React.createElement(Label, Object.assign({}, rest), label),
        dismissible && (React.createElement(ClosedIcon, Object.assign({}, rest, { onClick: onDismiss }), getIcon()))));
};
export default Component;
